import React from 'react';
import { usePermissions, useTranslate } from 'react-admin';
import { Drawer } from '~/components';
import { EditForm } from '~/components/ra';
import LegalConsentForm from './LegalConsentForm';
import useCrudGetManyReference from '~/hooks/useCrudGetManyReference';
import { LegalConsentFilters } from '~/types/LegalConsent';

interface LegalConsentEditProps {
  record: any;
  onClose: () => void;
  filters?: LegalConsentFilters;
  solutionId?: string;
}

const LegalConsentEdit = (props: LegalConsentEditProps) => {
  const { record, solutionId, onClose, filters } = props;
  const resource = 'legalConsents';
  const target = 'solutions';
  const targetId = solutionId || record?.solutionId;
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.legalConsents.fields.${key}`);
  const { permissions } = usePermissions();
  const crudGetManyReference = useCrudGetManyReference(resource, target, targetId, {
    sort: { field: 'created', order: 'DESC' },
    filters: filters,
  });
  if (!record) return null;
  return (
    <Drawer heading={t('editConsent')} open={!!record} onClose={onClose}>
      <EditForm
        resource={target}
        id={solutionId}
        subresource={resource}
        closeParent={onClose}
        record={record}
        withDelete
        updateAfterSubmit={() => targetId && crudGetManyReference()}
        onDeleteSuccess={() => targetId && crudGetManyReference()}
        disabled={!permissions?.includes('solution.legalConsent.update') || record?.deleted}
        deleteButtonProps={
          record?.deleted
            ? undefined
            : {
                variant: 'archive',
                disabled: !permissions?.includes('solution.legalConsent.delete'),
              }
        }
      >
        <LegalConsentForm edit />
      </EditForm>
    </Drawer>
  );
};

export default LegalConsentEdit;
